const buildContactNavigationTargetUrl = ({
  activeSubPage = "details",
  listContext = {},
  recordId,
  status = "all",
} = {}) => {
  const query = new URLSearchParams(listContext.locationSearch || "");
  query.set("status", status || query.get("status") || "all");
  return `/contacts/${recordId}/${activeSubPage}?${query.toString()}`;
};

export { buildContactNavigationTargetUrl };
